import { notify } from '@kyvg/vue3-notification'

export function createAwnCompatPlugin () {
  const awn = {
    options: { labels: {} },
    alert (text) {
      notify({ text: String(text ?? ''), type: 'error' })
    },
    success (text) {
      notify({ text: String(text ?? ''), type: 'success' })
    },
    warning (text) {
      notify({ text: String(text ?? ''), type: 'warn' })
    },
    info (text) {
      notify({ text: String(text ?? ''), type: 'info' })
    },
    confirm (message, onOk, onCancel) {
      const accepted = window.confirm(String(message ?? 'Are you sure?'))
      if (accepted) {
        if (typeof onOk === 'function') onOk()
      } else if (typeof onCancel === 'function') {
        onCancel()
      }
    },
    closeToasts () {
      // vue3-notification has no global clear API; keep as no-op for compat.
    },
    modal (content, className = '') {
      const existing = document.getElementById('awn-compat-modal')
      if (existing) existing.remove()

      const overlay = document.createElement('div')
      overlay.id = 'awn-compat-modal'
      overlay.className = `awn-compat-modal ${className}`.trim()
      overlay.innerHTML = `<div class="awn-compat-modal__content">${content}</div>`
      document.body.appendChild(overlay)
    }
  }

  return {
    install (app) {
      app.config.globalProperties.$awn = awn
    }
  }
}
